import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { getSessionToken } from 'util/parseSelectors';

import { ProtectedImg } from './ProtectedImage.styles';
import { isAPIUrl, openInNewTab } from '../../../util';

const ProtectedImage = ({ src, altText = '', className = '', onError = noop, isClickable = true }) => {
  const [imageSrc, setImageSrc] = useState('');

  useEffect(() => {
    if (isAPIUrl(src)) {
      const separator = src.includes('?') ? '&' : '?';
      setImageSrc(`${src}${separator}sessionToken=${getSessionToken()}`);
    } else {
      setImageSrc(src);
    }
  }, [src]);

  return (
    imageSrc && (
      <ProtectedImg
        src={imageSrc}
        alt={altText}
        onError={() => onError()}
        className={className}
        {...(isClickable && { onClick: () => openInNewTab(imageSrc) })}
      />
    )
  );
};

ProtectedImage.propTypes = {
  src: PropTypes.string.isRequired,
  altText: PropTypes.string,
  className: PropTypes.string,
  onError: PropTypes.func,
  isClickable: PropTypes.bool,
};

export default ProtectedImage;
